import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';
import angular from '../assets/angular.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import profile1 from '../assets/profile1.jpg';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import aws from '../assets/aws.svg';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';

import JohnDoe from '../assets/John_Doe.jpeg';
import Nrupendra from '../assets/Nrupendra.jpeg';
import Zahid from '../assets/Zahid.jpeg';
import Fraser from '../assets/Fraser.jpeg';
import Marcos from '../assets/Marcos.jpeg';
import Raja from '../assets/Raja.jpeg';

export default {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  angular,
  about01,
  about02,
  about03,
  about04,
  profile,
  profile1,
  circle,
  logo,
  adidas,
  amazon,
  aws,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  JohnDoe,
  Nrupendra,
  Zahid,
  Fraser, 
  Marcos,
  Raja,
  
};
